import * as React from 'react';
import PropTypes from 'prop-types';
var SvgAchievementsMedal03Small = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.577 6.851l2.358-5.143A.5.5 0 0017.48 1H6.522a.5.5 0 00-.455.708L8.425 6.85A7.995 7.995 0 0012 22a7.995 7.995 0 003.576-15.149zm-.914-.405L12.625 2H16.7l-2.038 4.446zM7.3 2h4.225L13.42 6.13a7.759 7.759 0 00-4.075.33L7.3 2zm4.904 15.15c-1.57 0-2.58-.88-2.75-2.39l1.17-.21c.15 1.01.61 1.49 1.58 1.49.76 0 1.23-.39 1.23-1.03 0-.68-.44-1.03-1.3-1.03h-.63v-.97h.55c.72 0 1.2-.35 1.2-.87 0-.55-.43-.91-1.12-.91-.76 0-1.26.39-1.37 1.06l-1.17-.2c.18-1.19 1.17-1.96 2.54-1.96s2.32.77 2.32 1.87c0 .6-.34 1.1-.88 1.36v.02c.65.28 1.07.91 1.07 1.71 0 1.18-.98 2.06-2.44 2.06z"
  }));
});
SvgAchievementsMedal03Small.defaultProps = {
  height: 24,
  width: 24
};
SvgAchievementsMedal03Small.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgAchievementsMedal03Small;